import {
	AccelerationUnit,
	NoneType,
	OverpressureUnit,
	VelocityUnit,
} from "@soft-db/data-formatter";
import { createPluginOptions } from "../create-plugin-options";

export const defaultVibrationEventSummaryDataOptions = createPluginOptions()({
	velocityUnit: "mm/s" as VelocityUnit | NoneType,
	accelerationUnit: "mm/s²" as AccelerationUnit | NoneType,
	oplUnit: "dB" as OverpressureUnit,
});

export type VibrationEventSummaryDataOptions = typeof defaultVibrationEventSummaryDataOptions;
